/**
 * @typedef {'Todos os chamados' | 'Em espera' | 'Em andamento' | 'Concluídos'} SupportStatusFilter
 * @typedef {'new' | 'indeterminate' | 'done' | string} JiraStatusCategoryKey
 * @typedef {'Muito Baixo' | 'Baixo' | 'Médio' | 'Alto' | 'Muito Alto'} PriorityPt
 *
 * @typedef {{ type?: string; attrs?: Record<string, unknown> }} JiraAdfMark
 *
 * @typedef {{
 *   type?: string;
 *   text?: string;
 *   content?: JiraAdfNode[];
 *   attrs?: Record<string, unknown>;
 *   marks?: JiraAdfMark[];
 * }} JiraAdfNode
 *
 * @typedef {{ type?: string; version?: number; content: unknown[] }} DescriptionDoc
 *
 * @typedef {{ name?: string | null; email?: string | null }} SupportIssueAuthor
 *
 * @typedef {{
 *   url?: string | null;
 *   filename?: string | null;
 *   external_id?: number | string | null;
 * }} SupportAttachment
 *
 * @typedef {{
 *   author?: SupportIssueAuthor | null;
 *   body?: DescriptionDoc | null;
 *   attachments?: SupportAttachment[] | null;
 *   created?: string | null;
 *   created_at?: string | null;
 *   external_id?: number | string | null;
 * }} SupportComment
 *
 * @typedef {{
 *   external_id?: string | number | null;
 *   external_key?: string | null;
 *   summary?: string | null;
 *   description?: DescriptionDoc | null;
 *   comments?: SupportComment[] | null;
 *   attachments?: SupportAttachment[] | null;
 *   author?: SupportIssueAuthor | null;
 *   status?: string | null;
 *   priority?: string | null;
 *   status_category_key?: string | null;
 *   status_name?: string | null;
 *   priority_name?: string | null;
 *   created_at?: string | null;
 *   updated_at?: string | null;
 * }} SupportIssue
 *
 * @typedef {{
 *   id?: string;
 *   filename?: string;
 *   size?: number;
 *   mimeType?: string;
 *   content?: string;
 *   thumbnail?: string;
 *   created?: string;
 *   author?: { displayName?: string };
 * }} SupportAttachmentViewModel
 *
 * @typedef {{
 *   id: string;
 *   authorName: string;
 *   createdAt?: string;
 *   updatedAt?: string;
 *   bodyAdf?: JiraAdfNode;
 *   bodyText?: string;
 *   attachments?: SupportAttachmentViewModel[];
 * }} SupportCommentViewModel
 *
 * @typedef {SupportCommentViewModel & { isMine?: boolean }} SupportChatMessage
 *
 * @typedef {{
 *   issueExternalId: string;
 *   id: string;
 *   key: string;
 *   title: string;
 *   content: string;
 *   authorName?: string;
 *   authorEmail?: string;
 *   descriptionAdf?: JiraAdfNode;
 *   statusCategoryKey: JiraStatusCategoryKey;
 *   statusName: string;
 *   priority: PriorityPt | 'Não definida';
 *   comments: number;
 *   createdAt?: string;
 *   updatedAt?: string;
 *   commentsList: SupportCommentViewModel[];
 *   attachments: SupportAttachmentViewModel[];
 * }} SupportIssueViewModel
 *
 * @typedef {{
 *   external_id?: string | null;
 *   external_key?: string | null;
 *   external_url?: string | null;
 *   response_status?: number | null;
 *   error?: string | null;
 *   created_at?: string | null;
 * }} CreateIssueResponse
 *
 * @typedef {{
 *   external_id?: string | null;
 *   external_url?: string | null;
 *   response_status?: number | null;
 *   error?: string | null;
 *   created_at?: string | null;
 * }} CreateCommentResponse
 *
 * @typedef {{
 *   external_id?: string | null;
 *   external_url?: string | null;
 *   response_status?: number | null;
 *   error?: string | null;
 *   created_at?: string | null;
 * }} CreateAttachmentResponse
 *
 * @typedef {{
 *   external_id?: string | null;
 *   response_status?: number | null;
 *   error?: string | null;
 * }} DeleteAttachmentResponse
 *
 * @typedef {{
 *   issues?: SupportIssue[] | null;
 *   response_status?: number | null;
 *   error?: string | null;
 * }} GetIssuesResponse
 *
 * @typedef {{
 *   issue?: SupportIssue | null;
 *   response_status?: number | null;
 *   error?: string | null;
 * }} GetIssueResponse
 *
 * @typedef {{
 *   comments?: SupportComment[] | null;
 *   response_status?: number | null;
 *   error?: string | null;
 * }} GetCommentsResponse
 */

export const SUPPORT_STATUS_FILTERS = /** @type {const} */ ([
  'Todos os chamados',
  'Em espera',
  'Em andamento',
  'Concluídos',
]);

export const PRIORITY_OPTIONS = /** @type {const} */ ([
  'Todas',
  'Muito Baixo',
  'Baixo',
  'Médio',
  'Alto',
  'Muito Alto',
  'Não definida',
]);
